import { AvatarDropdown, AvatarName, Question, SelectLang, ThemeToggle } from '@/components';
import { LinkOutlined } from '@ant-design/icons';
import { type Settings as LayoutSettings } from '@ant-design/pro-components';
import { Link, type RunTimeLayoutConfig } from '@umijs/max';
import React, { useState } from 'react';
import defaultSettings from '../config/defaultSettings';
import keycloak, { getUserPermissions } from '@/services/keycloak';
import { errorConfig } from './requestErrorConfig';


const isDev = process.env.NODE_ENV === 'development';

export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: any;
  loading?: boolean;
}> {
  try {
    //const authenticated = await keycloak.init({
    //  onLoad: 'check-sso',
    //  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    //  pkceMethod: 'S256',
    //});

    //if (!authenticated) {
    //  keycloak.login();
    //}

    //setInterval(async () => {
    //  try {
    //    await keycloak.updateToken(60);
    //  } catch (err) {
    //    keycloak.login();
    //  }
    //}, 30000);

    //const tokenParsed = keycloak.tokenParsed as any;
    //let permissions: any[] = [];
    //try {
    //  permissions = await getUserPermissions(keycloak);
    //} catch (e) {
    //  permissions = [];
    //}

    return {
      currentUser: {
        name: "John Doe",
        //employeeId: tokenParsed?.employeeId,
        //isManager: tokenParsed?.isManager,
        avatar: '',
        //permissions,
        permissions: []
      },
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  } catch (error) {
    keycloak.login();
    return {
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
}

export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }: any) => {
  const [collapsed, setCollapsed] = useState(false);

  return {
    breadcrumbRender: false,
    settingRender: false,
    collapsed,
    onCollapse: setCollapsed,
    onPageChange: async () => {
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    },
    actionsRender: () => [
      <Question key="doc" />,
      <SelectLang key="SelectLang" />,
      <ThemeToggle key="theme" />,
    ],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_: any, avatarChildren: any) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    bgLayoutImgList: [
      {
        src: '/bg-1.webp',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: '/bg-2.webp',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: '/bg-3.webp',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    links: isDev
      ? [
        <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
          <LinkOutlined />
          <span>OpenAPI Document</span>
        </Link>,
      ]
      : [],
    menuHeaderRender: undefined,
    childrenRender: (children) => {
      return <>{children}</>;
    },
    ...initialState?.settings,
  };
};

export const request = {
  ...errorConfig,
  requestInterceptors: [
    (url: string, options: any) => {
      const isFullUrl = /^http(s)?:\/\//.test(url);
      const finalUrl = isFullUrl ? url : `${API_URL}${url}`;
      const token = keycloak.token;
      
      return {
        url: finalUrl,
        options: {
          ...options,
          headers: {
            ...options.headers,
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        },
      };
    },
  ],
};
